import React, { useState, useEffect } from "react";
import { database } from "../firebaseConfig";
import { ref, update, onValue } from "firebase/database";
import "./MoreWorldSettings.css";

const MoreWorldSettings = ({ userId }) => {
  const [moreSettings, setMoreSettings] = useState({
    calendlyKey: ""
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isSaved, setIsSaved] = useState(false);

  // Lade vorhandene Einstellungen aus der Datenbank
  useEffect(() => {
    if (!userId) return;
    
    const moreSettingsRef = ref(database, `/World/${userId}/settings/moreSettings`);
    const unsubscribeListener = onValue(
      moreSettingsRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          // Nur den calendlyKey laden, eventTypes werden in Agent Settings verwaltet
          setMoreSettings({
            calendlyKey: data.calendlyKey || ""
          });
        }
      },
      (error) => {
        console.error("Fehler beim Laden der Extra Settings", error);
      }
    );

    return () => unsubscribeListener();
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMoreSettings(prev => ({
      ...prev,
      [name]: value
    }));
    setIsSaved(false);
  };

  const handleSave = async () => {
    if (!userId) {
      setMessage("User nicht gefunden.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const moreSettingsRef = ref(database, `/World/${userId}/settings/moreSettings`);
      await update(moreSettingsRef, {
        calendlyKey: moreSettings.calendlyKey.trim()
      });
      
      setMessage("Calendly API Key erfolgreich gespeichert! Sie können jetzt in den Agent Settings Event Types auswählen.");
      setIsSaved(true);
      
      setTimeout(() => {
        setMessage("");
        setIsSaved(false);
      }, 3000);
    } catch (error) {
      console.error("Fehler beim Speichern der Extra Settings:", error);
      setMessage("Fehler beim Speichern der Extra Settings: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="moreWorldSettingsContainer">
      <div className="settingsSection">
        <h3 className="sectionTitle">Calendly Settings</h3>
        
        <div className="settingGroup">
          <label className="settingLabel">
            Calendly API Key
            <span className="settingDescription">
              Geben Sie hier Ihren Calendly API Key ein für die Agent-Integration
            </span>
          </label>
          <input
            type="password"
            name="calendlyKey"
            value={moreSettings.calendlyKey}
            onChange={handleChange}
            className="settingInput"
            placeholder="Calendly API Key eingeben..."
          />
          
          {!moreSettings.calendlyKey && (
            <div className="calendlyHelp">
              <div className="helpIcon">💡</div>
              <div className="helpContent">
                <div className="helpTitle">How to get your Calendly API Key:</div>
                <div className="helpSteps">
                  <div className="helpStep">1. Log into your Calendly account</div>
                  <div className="helpStep">2. Go to Settings → Integrations → API & Webhooks</div>
                  <div className="helpStep">3. Generate a Personal Access Token</div>
                  <div className="helpStep">4. Copy and paste the token here</div>
                </div>
                <div className="helpNote">
                  ℹ️ Your API key is stored securely and only used to fetch your available meeting times.
                </div>
              </div>
            </div>
          )}
          
          {moreSettings.calendlyKey && (
            <div className="calendlySuccess">
              <div className="successIcon">✅</div>
              <div className="successContent">
                <div className="successTitle">Calendly API Key configured!</div>
                <div className="successDescription">
                  You can now go to <strong>Agent Settings</strong> and enable Calendly integration for your agents. 
                  Each agent can choose their own meeting types.
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="settingActions">
        <button 
          className={`saveSettingsButton ${isSaved ? 'saved' : ''}`} 
          onClick={handleSave}
          disabled={loading}
          style={{
            backgroundColor: isSaved ? '#10b981' : 'var(--blue)',
            transition: 'background-color 0.3s ease'
          }}
        >
          {loading ? 'Saving...' : isSaved ? 'Saved!' : 'Save Calendly API Key'}
        </button>
      </div>

      {message && (
        <p className={`world_settings_message ${message.includes('erfolgreich') ? 'success' : 'error'}`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default MoreWorldSettings; 